<section class="left-nav-wrapper scroll-container">
  <div class="d-flex">
    <div class="col-8">
      <h1 class="page-title fw-bold">My Pay</h1>
    </div>
    <div class="col-4">
      <lib-ee-client-switcher></lib-ee-client-switcher>
    </div>
  </div>
  <div *ngIf="years != null && years.length > 0" class="payStubs">
    @for (year of years; track year; let i = $index) {
      <div ngbAccordion #parentAccordion="ngbAccordion">
        <div
          ngbAccordionItem
          ngbAccordionItem="accItemName"
          #accItemName="ngbAccordionItem"
          [collapsed]="true">
          <h2 ngbAccordionHeader (click)="beforeYearPanelChange(year, i)">
            <button ngbAccordionButton>{{ year }}</button>
          </h2>
          <div ngbAccordionCollapse>
            <div ngbAccordionBody class="px-0">
              <ng-template>
                <div *ngIf="yearlyData[year] != null && yearlyData[year].length > 0">
                  <div class="list-group list-group-flush">
                    <div
                      class="list-group-item d-flex align-middle payline"
                      *ngFor="let period of yearlyData[year]">
                      <div class="row w-100">
                        <div class="col-md-5 mt-auto mb-auto">
                          <span class="fw-bold">Pay Date:</span>
                          {{ period.PayDate | date: 'MM/dd/yyyy' }}
                        </div>
                        <div class="col-md-3 mt-auto mb-auto">
                          <span class="fw-bold">Net Pay:</span> {{ period.NetPay | currency }}
                        </div>
                        <div class="col-md-2 mt-auto mb-auto">
                          <button
                            class="btn btn-primary btn-sm"
                            (click)="
                              showPayDetails(paydetailsModal, year, period.PayId, period.PaySeq)
                            ">
                            View Paystub
                          </button>
                        </div>
                        <div class="col-md-2 mt-auto mb-auto">
                          <button
                            class="btn btn-link btn-sm"
                            (click)="downloadStub(year, period.PayId, period.PaySeq)">
                            Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="yearlyData[year] != null && yearlyData[year].length == 0">
                  No Data for year {{ year }}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div *ngIf="years != null && years.length == 0" class="payStubs">
    <h3>There are no completed pay entries on file.</h3>
  </div>
</section>
<ng-template #paydetailsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Pay Details</h4>
    <button cpGTagEvent type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body paydetails">
    <div *ngIf="selectedStub != null">
      <div class="row">
        <div class="col fw-bold">Pay Date</div>
        <div class="col fw-bold">Period Begin</div>
        <div class="col fw-bold">Period End</div>
        <div class="col fw-bold">Net Pay</div>
      </div>
      <div class="row mb-3">
        <div class="col">{{ selectedStub.PayDate | date: 'MM/dd/yyyy' }}</div>
        <div class="col">{{ selectedStub.PeriodBegin | date: 'MM/dd/yyyy' }}</div>
        <div class="col">{{ selectedStub.PeriodEnd | date: 'MM/dd/yyyy' }}</div>
        <div class="col">{{ selectedStub.NetPay | currency }}</div>
      </div>
      <!-- Earnings -->
      <div class="mb-4" *ngIf="selectedStub.Earnings && selectedStub.Earnings.length > 0">
        <div class="row">
          <div class="col fw-bold">Earnings</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col fw-bold align-right">Rate/Amt</div>
          <div class="col fw-bold align-right">Hours</div>
          <div class="col fw-bold align-right">YTD Hrs</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Year to Date</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Earnings">
          <div class="col">{{ item.EarningName }}</div>
          <div class="col align-right">{{ item.RateAmount | currency }}</div>
          <div class="col align-right">{{ item.Hours | number: '1.2-2' }}</div>
          <div class="col align-right">{{ item.YtdHours | number: '1.2-2' }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.YtdAmount | currency }}</div>
        </div>
        <div class="row">
          <div class="col fw-bold">Total</div>
          <div class="col fw-bold align-right">&nbsp;</div>
          <div class="col fw-bold align-right">
            {{ groupTotal('Earnings', 'Hours') | number: '1.2-2' }}
          </div>
          <div class="col fw-bold align-right">
            {{ groupTotal('Earnings', 'YtdHours') | number: '1.2-2' }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Earnings', 'Amount') | currency }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Earnings', 'YtdAmount') | currency }}
          </div>
        </div>
      </div>
      <!-- Taxes -->
      <div class="mb-4" *ngIf="selectedStub.Taxes && selectedStub.Taxes.length > 0">
        <div class="row">
          <div class="col fw-bold">Taxes</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Year to Date</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Taxes">
          <div class="col">{{ item.TaxName }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.YtdAmount | currency }}</div>
        </div>
        <div class="row">
          <div class="col fw-bold">Total</div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Taxes', 'Amount') | currency }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Taxes', 'YtdAmount') | currency }}
          </div>
        </div>
      </div>
      <!-- Deductions -->
      <div class="mb-4" *ngIf="selectedStub.Deductions && selectedStub.Deductions.length > 0">
        <div class="row">
          <div class="col fw-bold">Deductions</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col fw-bold align-right">Rate/Amt</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Year to Date</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Deductions">
          <div class="col">{{ item.DeductionName }}</div>
          <div class="col align-right">{{ item.RateAmount | currency }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.YtdAmount | currency }}</div>
        </div>
        <div class="row">
          <div class="col fw-bold">Total</div>
          <div class="col fw-bold align-right">
            {{ groupTotal('Deductions', 'RateAmount') | currency }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Deductions', 'Amount') | currency }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Deductions', 'YtdAmount') | currency }}
          </div>
        </div>
      </div>

      <!-- Others -->
      <div class="mb-4" *ngIf="selectedStub.Others && selectedStub.Others.length > 0">
        <div class="row">
          <div class="col fw-bold">Others</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col fw-bold align-right">Hours</div>
          <div class="col fw-bold align-right">YTD Hrs</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Year to Date</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Others">
          <div class="col">{{ item.OtherName }}</div>
          <div class="col align-right">{{ item.Hours | number: '1.2-2' }}</div>
          <div class="col align-right">{{ item.YtdHours | number: '1.2-2' }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.YtdAmount | currency }}</div>
        </div>
        <div class="row">
          <div class="col fw-bold">Total</div>
          <div class="col fw-bold align-right">
            {{ groupTotal('Others', 'Hours') | number: '1.2-2' }}
          </div>
          <div class="col fw-bold align-right">
            {{ groupTotal('Others', 'YtdHours') | number: '1.2-2' }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Others', 'Amount') | currency }}
          </div>
          <div class="col-2 fw-bold align-right">
            {{ groupTotal('Others', 'YtdAmount') | currency }}
          </div>
        </div>
      </div>

      <!-- Time Off -->
      <div class="mb-4" *ngIf="selectedStub.TimeOffs && selectedStub.TimeOffs.length > 0">
        <div class="row">
          <div class="col fw-bold">Paid Time Off</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col fw-bold align-right">Accrued</div>
          <div class="col fw-bold align-right">Used</div>
          <div class="col-2 fw-bold align-right">Remaining</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.TimeOffs">
          <div class="col">{{ item.TimeoffName }}</div>
          <div class="col align-right">{{ item.Accrued | number: '1.2-2' }}</div>
          <div class="col align-right">{{ item.Used | number: '1.2-2' }}</div>
          <div class="col-2 align-right">{{ item.Remaining | number: '1.2-2' }}</div>
        </div>
      </div>

      <!-- Memos -->
      <div class="mb-4" *ngIf="selectedStub.Memos && selectedStub.Memos.length > 0">
        <div class="row">
          <div class="col fw-bold">Memos</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col fw-bold align-right">Hours</div>
          <div class="col fw-bold align-right">YTD Hrs</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Year to Date</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Memos">
          <div class="col">{{ item.MemoName }}</div>
          <div class="col align-right">{{ item.Hours | number: '1.2-2' }}</div>
          <div class="col align-right">{{ item.YtdHours | number: '1.2-2' }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.YtdAmount | currency }}</div>
        </div>
      </div>

      <!-- Loans -->
      <div class="mb-4" *ngIf="selectedStub.Loans && selectedStub.Loans.length > 0">
        <div class="row">
          <div class="col fw-bold">Loans</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">&nbsp;</div>
          <div class="col-2 fw-bold align-right">Current</div>
          <div class="col-2 fw-bold align-right">Balance</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.Loans">
          <div class="col">{{ item.LoanName }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
          <div class="col-2 align-right">{{ item.Balance | currency }}</div>
        </div>
      </div>

      <!-- Direct Deposits -->
      <div class="mb-4" *ngIf="selectedStub.DirectDeposit && selectedStub.DirectDeposit.length > 0">
        <div class="row">
          <div class="col fw-bold">Direct Deposit</div>
        </div>
        <div class="row">
          <div class="col">
            <hr class="mt-1 mb-1" />
          </div>
        </div>
        <div class="row">
          <div class="col">Account</div>
          <div class="col-2 fw-bold align-left">Type</div>
          <div class="col-2 fw-bold align-right">Amount</div>
        </div>
        <div class="row" *ngFor="let item of selectedStub.DirectDeposit">
          <div class="col">{{ item.AccountNo }}</div>
          <div class="col-2 align-left">{{ item.AccountType }}</div>
          <div class="col-2 align-right">{{ item.Amount | currency }}</div>
        </div>
      </div>

      <!-- Net Pay -->
      <div class="mb-4">
        <div class="row">
          <div class="col fw-bold">Net Pay</div>
          <div class="col-2 fw-bold align-right">{{ selectedStub.NetPay | currency }}</div>
          <div class="col-2 fw-bold align-right">{{ selectedStub.YtdNetPay | currency }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button cpGTagEvent type="button" class="btn btn-primary" (click)="modal.dismiss()">
      Close
    </button>
  </div>
</ng-template>
